import React from 'react';
import { MdOutlineSatelliteAlt } from 'react-icons/md';
import { useSelector } from 'react-redux';

import { Top as TopUI, TopNotificationCount, TopStatusValue } from '@/components/ui/dashboard/Top';

const Top = ({ robot }) => {
  const gpsRaw = useSelector((state) => state.telemetry[robot.id].gpsRaw);

  return (
    <TopUI agentType={robot.model.agentType} owned={robot.isOwned} robotId={robot.id}>
      <TopStatusValue Icon={MdOutlineSatelliteAlt} value={gpsRaw?.satellitesVisible} style={{ gap: 4 }} />
      <TopNotificationCount robotId={robot.id} />
    </TopUI>
  );
};

export default Top;
